import React, { useEffect, useState, useRef, useCallback } from "react";
import Login from "./Login";
import { Link, useNavigate } from "react-router-dom";
import { NavDropdown } from "react-bootstrap";
import TopBarAnnouncement from "../components/TopBarAnnouncement";
import { v4 as uuidv4 } from "uuid";
import { enrichGuestCartItems } from "../components/guestCart";
import("feather-icons").then((feather) => feather.default.replace());

const GUEST_CART_KEY = "guest_cart";
const sendPurchaseEvent = async (value) => {
  const eventId = uuidv4();

  if (window.fbq) {
    window.fbq(
      "track",
      "Purchase",
      {
        value: value,
        currency: "INR",
      },
      {
        eventID: eventId,
      },
    );
  }

  await fetch("https://evercorenutrition.com/ev_admin/api/fb-event/", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      event_id: eventId,
      value: value,
    }),
  });
};

export default function Navbar({ setopen, open }) {
  const [showSearch, setShowSearch] = useState(false);
  const [showLogin, setshowLogin] = useState(false);
  const [showCartSidebar, setShowCartSidebar] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userData, setUserData] = useState(null);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [wishlistCount, setWishlistCount] = useState(0);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const [cartData, setCartData] = useState(null);
  const [guestCartData, setGuestCartData] = useState(null);
  const [pendingCheckoutAction, setPendingCheckoutAction] = useState(false);
  const [isMergingCart, setIsMergingCart] = useState(false);

  // Add state for logout confirmation popup
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  // Tooltip states
  const [tooltipText, setTooltipText] = useState("");
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const tooltipTimeoutRef = useRef(null);

  const [orderSummary, setOrderSummary] = useState({
    subtotal: 0,
    total: 0,
    itemCount: 0,
  });
  const [promos, setPromos] = useState([]);
  const [currentPromoIndex, setCurrentPromoIndex] = useState(0);
  const [promoLoading, setPromoLoading] = useState(true);
  const [isFetchingProfile, setIsFetchingProfile] = useState(false);
  const [isFetchingWishlist, setIsFetchingWishlist] = useState(false);
  const [isFetchingCart, setIsFetchingCart] = useState(false);
  const [promoInterval, setPromoInterval] = useState(null);

  // State for recommended products and combos
  const [recommendedProducts, setRecommendedProducts] = useState([]);
  const [isLoadingRecommended, setIsLoadingRecommended] = useState(false);

  // New state for bestseller combos
  const [bestsellerCombos, setBestsellerCombos] = useState([]);
  const [isLoadingCombos, setIsLoadingCombos] = useState(false);

  const [messages, setMessages] = useState([]);
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [messagesLoading, setMessagesLoading] = useState(true);

  // Tooltip handler functions
  const showTooltipMessage = (message, event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setTooltipText(message);
    setTooltipPosition({
      x: rect.left + rect.width / 2,
      y: rect.top - 10,
    });
    setShowTooltip(true);

    if (tooltipTimeoutRef.current) {
      clearTimeout(tooltipTimeoutRef.current);
    }
    tooltipTimeoutRef.current = setTimeout(() => {
      setShowTooltip(false);
    }, 2000);
  };

  const hideTooltip = () => {
    if (tooltipTimeoutRef.current) {
      clearTimeout(tooltipTimeoutRef.current);
    }
    setShowTooltip(false);
  };

  // Fetch bestseller combos
  const fetchBestsellerCombos = useCallback(async () => {
    setIsLoadingCombos(true);
    try {
      
      const response = await fetch(
        "https://evercorenutrition.com/ev_admin/api/combos/",
      );

      if (!response.ok) {
        console.error("API response not OK:", response.status);
        throw new Error(`Failed to fetch combos: ${response.status}`);
      }

      const data = await response.json();
      

      let combosArray = [];

      // Handle the actual API response format with 'results' array
      if (data.results && Array.isArray(data.results)) {
        combosArray = data.results;
       
      } else if (Array.isArray(data)) {
        combosArray = data;
       
      } else {
        console.warn(
          "Unexpected API response format for combos:",
          Object.keys(data),
        );
        // Try to find any array property
        for (const key in data) {
          if (Array.isArray(data[key]) && data[key].length > 0) {
            combosArray = data[key];
          
            break;
          }
        }
      }

      if (combosArray.length > 0) {
        // Filter combos that are bestseller or most popular
        const bestsellerCombosList = combosArray.filter(
          (combo) =>
            combo.is_bestseller === true || combo.is_most_popular === true,
        );



        if (bestsellerCombosList.length > 0) {
          // Take first 2 bestseller combos (or show all up to 2)
          const selectedCombos = bestsellerCombosList.slice(0, 2);
          setBestsellerCombos(selectedCombos);

        } else {
          console.warn("No bestseller combos found");
          setBestsellerCombos([]);
        }
      } else {
        console.warn("No combos found in API response");
        setBestsellerCombos([]);
      }
    } catch (error) {
      console.error("Error fetching bestseller combos:", error);
      setBestsellerCombos([]);
    } finally {
      setIsLoadingCombos(false);
    }
  }, []);

  // Fetch recommended products (bestsellers only)
  const fetchRecommendedProducts = useCallback(async () => {
    setIsLoadingRecommended(true);
    try {

      const response = await fetch(
        "https://evercorenutrition.com/ev_admin/api/productslist/",
      );

      if (!response.ok) {
        console.error("API response not OK:", response.status);
        throw new Error(`Failed to fetch products: ${response.status}`);
      }

      const data = await response.json();
  

      let productsArray = [];

      // Handle the actual API response format with 'results' array
      if (data.results && Array.isArray(data.results)) {
        productsArray = data.results;
      
      } else if (data.count !== undefined && Array.isArray(data.results)) {
        productsArray = data.results;

      } else if (data.success && Array.isArray(data.products)) {
        productsArray = data.products;

      } else if (Array.isArray(data)) {
        productsArray = data;

      } else {
        console.warn("Unexpected API response format:", Object.keys(data));
        // Try to find any array property
        for (const key in data) {
          if (Array.isArray(data[key]) && data[key].length > 0) {
            productsArray = data[key];

            break;
          }
        }
      }

      if (productsArray.length > 0) {
        // Filter products that have is_bestseller true
        const bestsellerProducts = productsArray.filter((product) => {
          // Check if product has any variant that is bestseller
          if (product.variants && Array.isArray(product.variants)) {
            const hasBestsellerVariant = product.variants.some(
              (variant) => variant.is_bestseller === true,
            );
            if (hasBestsellerVariant) {
              return true;
            }
          }
          // Also check if product itself has is_bestseller property
          return product.is_bestseller === true;
        });

        if (bestsellerProducts.length > 0) {
          // Take first 2 bestseller products
          const selected = bestsellerProducts.slice(0, 2);
          setRecommendedProducts(selected);

        } else {
          console.warn(
            "No bestseller products found, showing regular products as fallback",
          );
          // Fallback: show first 2 active products
          const activeProducts = productsArray.filter(
            (p) => p.is_active === true || p.status === "Active",
          );
          const fallbackProducts = activeProducts.slice(0, 2);
          setRecommendedProducts(fallbackProducts);

        }
      } else {
        console.warn("No products found in API response");
      }
    } catch (error) {
      console.error("Error fetching recommended products:", error);
    } finally {
      setIsLoadingRecommended(false);
    }
  }, []);

  // Add combo to cart
  const addComboToCart = async (combo) => {
    if (isAuthenticated) {
      try {
        const token = localStorage.getItem("authToken");
        const customerId = getCustomerId();

        if (!token || !customerId) return;

        const requestBody = {
          customer_id: String(customerId),
          combo_id: combo.id,
          quantity: 1,
        };


        const response = await fetch(
          "https://evercorenutrition.com/ev_admin/api/cart/",
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          },
        );

        if (response.ok) {
          await fetchCartData();
          window.dispatchEvent(new Event("cartUpdated"));
        } else {
          console.error("Failed to add combo to cart:", await response.text());
        }
      } catch (error) {
        console.error("Error adding combo to cart:", error);
      }
    } else {
      // Guest cart logic for combo
      const guestCart = getGuestCart();

      const existingItemIndex = guestCart.findIndex(
        (item) => item.combo_id === combo.id && item.item_type === "combo",
      );

      const comboSellingPrice = parseFloat(
        combo.selling_price || combo.discount_price || 0
      );

      const comboOriginalMRP = parseFloat(
        combo.mrp || combo.price || combo.original_price || comboSellingPrice
      );

      const newItem = {
        combo_id: combo.id,
        name: combo.name,
        combo_name: combo.name,
        quantity: 1,
        unit_price: comboSellingPrice,
        price: comboSellingPrice,
        original_mrp: comboOriginalMRP,
        variant_mrp: comboOriginalMRP,
        image: combo.image_url || combo.image,
        combo_image: combo.image_url || combo.image,
        item_type: "combo",
      };

      if (existingItemIndex >= 0) {
        guestCart[existingItemIndex].quantity += 1;
      } else {
        guestCart.push(newItem);
      }

      saveGuestCart(guestCart);
      fetchGuestCart();
      window.dispatchEvent(new Event("guestCartUpdated"));
    }
  };
  // Add this with your other useEffect hooks
  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const response = await fetch(
          "https://evercorenutrition.com/ev_admin/api/messages/",
        );
        if (!response.ok) throw new Error("Failed to fetch messages");
        const data = await response.json();
        if (
          data.success &&
          Array.isArray(data.messages) &&
          data.messages.length > 0
        ) {
          setMessages(data.messages);
          // Auto-rotate messages continuously
          if (data.messages.length > 1) {
            const interval = setInterval(() => {
              setCurrentMessageIndex(
                (prev) => (prev + 1) % data.messages.length,
              );
            }, 5000);
            return () => clearInterval(interval);
          }
        }
      } catch (err) {
        console.error("Error fetching messages:", err);
      } finally {
        setMessagesLoading(false);
      }
    };

    fetchMessages();
    fetchRecommendedProducts();
    fetchBestsellerCombos(); // Fetch bestseller combos
  }, []);

  // Remove Bootstrap backdrop
  useEffect(() => {
    const removeBackdrop = () => {
      document
        .querySelectorAll(".offcanvas-backdrop")
        .forEach((el) => el.remove());
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
      document.body.classList.remove("modal-open");
    };

    const offcanvasEl = document.getElementById("primaryMenu");
    if (offcanvasEl) {
      offcanvasEl.addEventListener("hidden.bs.offcanvas", removeBackdrop);
      return () =>
        offcanvasEl.removeEventListener("hidden.bs.offcanvas", removeBackdrop);
    }
  }, []);

  // Prevent body scroll when cart sidebar is open
  useEffect(() => {
    if (showCartSidebar) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [showCartSidebar]);

  // Guest cart functions
  const getGuestCart = useCallback(() => {
    try {
      const cart = localStorage.getItem(GUEST_CART_KEY);
      return cart ? JSON.parse(cart) : [];
    } catch (error) {
      console.error("Error getting guest cart:", error);
      return [];
    }
  }, []);

  const saveGuestCart = useCallback((cartItems) => {
    try {
      localStorage.setItem(GUEST_CART_KEY, JSON.stringify(cartItems));
    } catch (error) {
      console.error("Error saving guest cart:", error);
    }
  }, []);

  const clearGuestCart = useCallback(() => {
    try {
      localStorage.removeItem(GUEST_CART_KEY);
    } catch (error) {
      console.error("Error clearing guest cart:", error);
    }
  }, []);

  const fetchGuestCart = useCallback(async () => {
    const guestCart = getGuestCart();

    if (guestCart.length > 0 && !isAuthenticated) {
      const enrichedCart = await enrichGuestCartItems(guestCart);

      const normalizedItems = enrichedCart.map((item) => {
        const itemPrice = parseFloat(item.unit_price || item.price || 0);

        const itemMRP = parseFloat(
          item.variant_mrp ||
            item.original_mrp ||
            item.mrp ||
            item.product_mrp ||
            item.original_price ||
            itemPrice
        );

        return {
          ...item,
          unit_price: itemPrice,
          price: itemPrice,
          variant_mrp: itemMRP,
          original_mrp: itemMRP,
          item_type: item.item_type || "product",
          id: item.combo_id || item.variant_id || item.product_id,
          combo_id: item.combo_id,
          product_id: item.product_id,
          variant_id: item.variant_id,
        };
      });

      const subtotal = normalizedItems.reduce(
        (sum, item) => sum + parseFloat(item.unit_price || 0) * item.quantity,
        0
      );

      setGuestCartData({
        items: normalizedItems,
        total_items: normalizedItems.reduce((sum, item) => sum + item.quantity, 0),
        total_quantity: normalizedItems.reduce((sum, item) => sum + item.quantity, 0),
      });

      setOrderSummary({
        subtotal,
        total: subtotal,
        itemCount: normalizedItems.reduce((sum, item) => sum + item.quantity, 0),
      });
    } else {
      setGuestCartData(null);

      if (isAuthenticated && cartData) {
        const subtotal = cartData.items.reduce(
          (sum, item) =>
            sum + parseFloat(item.unit_price || item.price || 0) * item.quantity,
          0
        );

        setOrderSummary({
          subtotal,
          total: subtotal,
          itemCount: cartData.total_items || cartData.items.length,
        });
      } else if (!isAuthenticated) {
        setOrderSummary({ subtotal: 0, total: 0, itemCount: 0 });
      }
    }
  }, [isAuthenticated, getGuestCart, cartData]);
  // Merge guest cart with user cart
  const mergeGuestCartWithUserCart = useCallback(
    async (customerId, token) => {
      const guestCart = getGuestCart();

      if (!guestCart || guestCart.length === 0) {
        return { success: true, mergedCount: 0 };
      }


      let mergedCount = 0;
      let errors = [];

      try {
        for (const item of guestCart) {
          const requestBody = {
            customer_id: String(customerId),
            quantity: item.quantity,
          };

          if (item.item_type === "combo") {
            requestBody.combo_id = item.combo_id;
          } else {
            requestBody.product_id = item.product_id;
            if (
              item.variant_id &&
              item.variant_id !== "null" &&
              item.variant_id !== null
            ) {
              requestBody.variant_id = item.variant_id;
            }
          }



          const response = await fetch(
            "https://evercorenutrition.com/ev_admin/api/cart/",
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify(requestBody),
            },
          );

          if (response.ok) {
            mergedCount++;
          } else {
            const errorData = await response.json().catch(() => ({}));
            errors.push({ item, error: errorData });
          }
        }

        if (mergedCount > 0) {
          clearGuestCart();
        }

        return { success: true, mergedCount, errors };
      } catch (error) {
        console.error("Error merging guest cart in Navbar:", error);
        return {
          success: false,
          message: "Failed to merge guest cart",
          errors,
        };
      }
    },
    [getGuestCart, clearGuestCart],
  );

  // src/utils/guestCart.js



  const getCartImage = (item) => {
    if (item.item_type === "combo" && item.combo_image) {
      return item.combo_image.startsWith("http")
        ? item.combo_image
        : `https://evercorenutrition.com${item.combo_image}`;
    }
    if (item.variant_image) {
      return item.variant_image.startsWith("http")
        ? item.variant_image
        : `https://evercorenutrition.com${item.variant_image}`;
    }
    if (item.product_image) {
      return item.product_image.startsWith("http")
        ? item.product_image
        : `https://evercorenutrition.com${item.product_image}`;
    }
    if (item.image) {
      return item.image.startsWith("http")
        ? item.image
        : `https://evercorenutrition.com${item.image}`;
    }
    return null;
  };

  const getItemName = (item) => {
    if (item.item_type === "combo") {
      return item.combo_name || item.name || "Combo Offer";
    }
    if (item.product_name) return item.product_name;
    if (item.display_name) return item.display_name;
    if (item.name) return item.name;
    return "Product";
  };

  const getVariantDisplay = (item) => {
    if (item.item_type === "combo") return null;
    const parts = [];
    if (item.variant_flavour && item.variant_flavour !== "Default") {
      parts.push(item.variant_flavour);
    }
    if (item.variant_weight_display) {
      parts.push(item.variant_weight_display);
    }
    return parts.length > 0 ? parts.join(" • ") : null;
  };

  const getComboItemsPreview = (item) => {
    if (item.item_type !== "combo" || !item.combo_items_list) return null;
    return item.combo_items_list
      .map((ci) => {
        const variant = ci.variant_name ? ` (${ci.variant_name})` : "";
        const weight = ci.weight_value
          ? ` - ${ci.weight_value}${ci.weight_unit}`
          : "";
        return `${ci.product_name}${variant}${weight}`;
      })
      .join(" + ");
  };

  const fetchUserProfile = useCallback(async () => {
    if (isFetchingProfile) return null;
    try {
      const token = localStorage.getItem("authToken");
      if (!token) return null;
      setIsFetchingProfile(true);
      const response = await fetch(
        "https://evercorenutrition.com/ev_admin/api/customer/profile/",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (response.ok) {
        const data = await response.json();
        const userProfile = data.user || data.customer || data;
        localStorage.setItem("userData", JSON.stringify(userProfile));
        return userProfile;
      } else if (response.status === 401) {
        localStorage.removeItem("authToken");
        localStorage.removeItem("userData");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("customer_id");
        setIsAuthenticated(false);
        setUserData(null);
      }
      return null;
    } catch (error) {
      console.error("Error fetching user profile:", error);
      return null;
    } finally {
      setIsFetchingProfile(false);
    }
  }, [isFetchingProfile]);

  useEffect(() => {
    const fetchPromos = async () => {
      try {
        const response = await fetch(
          "https://evercorenutrition.com/ev_admin/api/promos/",
        );
        if (!response.ok) throw new Error("Failed to fetch promos");
        const data = await response.json();
        if (data.success && Array.isArray(data.promocodes)) {
          setPromos(data.promocodes);
          setCurrentPromoIndex(
            Math.floor(Math.random() * data.promocodes.length),
          );
          if (promoInterval) clearInterval(promoInterval);
          const interval = setInterval(() => {
            setCurrentPromoIndex((prev) => (prev + 1) % data.promocodes.length);
          }, 20000);
          setPromoInterval(interval);
        }
      } catch (err) {
        console.error("Error fetching promos:", err);
      } finally {
        setPromoLoading(false);
      }
    };
    fetchPromos();
    return () => {
      if (promoInterval) clearInterval(promoInterval);
    };
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      fetchWishlistCount();
      fetchCartData();
    } else {
      setWishlistCount(0);
      setCartData(null);
      fetchGuestCart();
    }
  }, [isAuthenticated, fetchGuestCart]);

  useEffect(() => {
    let intervalId;
    if (isAuthenticated) {
      intervalId = setInterval(
        async () => {
          const profileData = await fetchUserProfile();
          if (profileData) setUserData(profileData);
        },
        5 * 60 * 1000,
      );
    }
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [isAuthenticated, fetchUserProfile]);

  useEffect(() => {
    checkAuthStatus();
    window.addEventListener("storage", checkAuthStatus);
    return () => window.removeEventListener("storage", checkAuthStatus);
  }, []);

  useEffect(() => {
    if (cartData?.items?.length > 0 && isAuthenticated) {
      const subtotal = cartData.items.reduce(
        (sum, item) =>
          sum + parseFloat(item.unit_price || item.price || 0) * item.quantity,
        0,
      );
      setOrderSummary({
        subtotal,
        total: subtotal,
        itemCount: cartData.total_items || cartData.items.length,
      });
    } else if (!isAuthenticated) {
      fetchGuestCart();
    }
  }, [cartData, isAuthenticated, fetchGuestCart]);

  const silentRefresh = useCallback(async () => {
    if (isAuthenticated) {
      await Promise.all([fetchWishlistCount(true), fetchCartData(true)]);
    } else {
      await fetchGuestCart();
    }
  }, [isAuthenticated, fetchGuestCart]);

  useEffect(() => {
    const handleCartUpdate = () => silentRefresh();
    const handleWishlistUpdate = () => silentRefresh();
    const handleGuestCartUpdate = () => fetchGuestCart();
    window.addEventListener("cartUpdated", handleCartUpdate);
    window.addEventListener("wishlistUpdated", handleWishlistUpdate);
    window.addEventListener("guestCartUpdated", handleGuestCartUpdate);
    return () => {
      window.removeEventListener("cartUpdated", handleCartUpdate);
      window.removeEventListener("wishlistUpdated", handleWishlistUpdate);
      window.removeEventListener("guestCartUpdated", handleGuestCartUpdate);
    };
  }, [silentRefresh, fetchGuestCart]);

  const fetchWishlistCount = useCallback(
    async (isSilent = false) => {
      if (isFetchingWishlist) return;
      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          if (!isSilent) setWishlistCount(0);
          return;
        }
        let customerId = null;
        try {
          const ud = localStorage.getItem("userData");
          if (ud) {
            const p = JSON.parse(ud);
            customerId = p.id || p.customer_id || null;
          }
        } catch (e) {}
        if (!customerId) return;
        setIsFetchingWishlist(true);
        const response = await fetch(
          `https://evercorenutrition.com/ev_admin/api/wishlist/?customer_id=${customerId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        );
        if (response.ok) {
          const data = await response.json();
          setWishlistCount(
            data?.wishlist?.total_items ||
              data?.wishlist?.products?.length ||
              0,
          );
        } else if (response.status === 401) {
          localStorage.removeItem("authToken");
          setIsAuthenticated(false);
          if (!isSilent) setWishlistCount(0);
        }
      } catch (error) {
        console.error("Error fetching wishlist count:", error);
      } finally {
        setIsFetchingWishlist(false);
      }
    },
    [isFetchingWishlist],
  );

  const fetchCartData = useCallback(
    async (isSilent = false) => {
      if (isFetchingCart) return;
      try {
        const token = localStorage.getItem("authToken");
        if (!token) return;
        let customerId = null;
        try {
          const ud = localStorage.getItem("userData");
          if (ud) {
            const p = JSON.parse(ud);
            customerId = p.id || p.customer_id || null;
          }
        } catch (e) {}
        if (!customerId) return;
        setIsFetchingCart(true);
        const response = await fetch(
          `https://evercorenutrition.com/ev_admin/api/cart/?customer_id=${customerId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        );
        if (response.ok) {
          const data = await response.json();
          if (data.success) {
            const normalized = {
              ...data.cart,
              items: (data.cart.items || []).map((item) => ({
                ...item,
                unit_price: parseFloat(item.unit_price || item.price || 0),
                item_type: item.combo_id ? "combo" : "product",
              })),
            };
            setCartData(normalized);
          }
        }
      } catch (err) {
        console.error("Error fetching cart:", err);
      } finally {
        setIsFetchingCart(false);
      }
    },
    [isFetchingCart],
  );

  const checkAuthStatus = useCallback(async () => {
    const token = localStorage.getItem("authToken");
    if (token) {
      setIsAuthenticated(true);
      const profileData = await fetchUserProfile();
      if (profileData) {
        setUserData(profileData);
      } else {
        const user = localStorage.getItem("userData");
        if (user) {
          try {
            setUserData(JSON.parse(user));
          } catch (e) {}
        }
      }
    } else {
      setIsAuthenticated(false);
      setUserData(null);
      setWishlistCount(0);
      setCartData(null);
      fetchGuestCart();
    }
  }, [fetchUserProfile, fetchGuestCart]);

  // Handle login success with guest cart merge
  const handleLoginSuccess = useCallback(
    async (user) => {
      setIsAuthenticated(true);
      setUserData(user);
      setshowLogin(false);

      const token = localStorage.getItem("authToken");
      const customerId = getCustomerId();

      if (token && customerId) {
        setIsMergingCart(true);

        // Merge guest cart with user cart
        const mergeResult = await mergeGuestCartWithUserCart(customerId, token);

        // Refresh cart data
        await fetchCartData();

        setIsMergingCart(false);

        // If checkout was pending, redirect to checkout
        if (pendingCheckoutAction) {
          setPendingCheckoutAction(false);
          setShowCartSidebar(false);
          setTimeout(() => {
            navigate("/Cart");
          }, 500);
        }
      }

      // Refresh wishlist after login
      await fetchWishlistCount();
      window.dispatchEvent(new Event("cartUpdated"));
      window.dispatchEvent(new Event("wishlistUpdated"));
    },
    [
      mergeGuestCartWithUserCart,
      fetchCartData,
      fetchWishlistCount,
      pendingCheckoutAction,
      navigate,
    ],
  );

  const getCustomerId = () => {
    try {
      const u = localStorage.getItem("userData");
      if (u) {
        const p = JSON.parse(u);
        return p.id || p.customer_id || null;
      }
    } catch (e) {}
    return null;
  };

  // Updated handleLogout with confirmation
  const handleLogout = useCallback(async () => {
    setIsLoggingOut(true);

    // Simulate a small delay for better UX
    await new Promise((resolve) => setTimeout(resolve, 500));

    localStorage.removeItem("authToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("customer_id");
    localStorage.removeItem("wishlist");
    setIsAuthenticated(false);
    setUserData(null);
    setShowUserDropdown(false);
    setWishlistCount(0);
    setCartData(null);
    fetchGuestCart();
    setShowLogoutConfirm(false);
    setIsLoggingOut(false);
    navigate("/");
  }, [navigate, fetchGuestCart]);

  // Open logout confirmation popup
  const openLogoutConfirm = (e) => {
    e.stopPropagation();
    setShowLogoutConfirm(true);
    setShowUserDropdown(false);
  };

  const toggleUserDropdown = (e) => {
    e.stopPropagation();
    setShowUserDropdown(!showUserDropdown);
  };
  const handleDropdownItemClick = useCallback(
    (path) => {
      setShowUserDropdown(false);
      navigate(path);
    },
    [navigate],
  );

  // Handle checkout click - show login for guests
  const handleCheckoutClick = useCallback(() => {
    setShowCartSidebar(false);

    const cartTotal = orderSummary.total;
    if (cartTotal > 0) {
      sendPurchaseEvent(cartTotal);
    }

    if (!isAuthenticated) {
      setPendingCheckoutAction(true);
      setshowLogin(true);
    } else {
      navigate("/Checkout");
    }
  }, [isAuthenticated, navigate]);

  // Add to cart function for recommended products
  const addToCartFromRecommended = async (product) => {
    if (isAuthenticated) {
      try {
        const token = localStorage.getItem("authToken");
        const customerId = getCustomerId();

        if (!token || !customerId) return;

        // Find the bestseller variant first, otherwise use first variant
        let defaultVariant = null;
        if (product.variants && product.variants.length > 0) {
          defaultVariant =
            product.variants.find((v) => v.is_bestseller === true) ||
            product.variants[0];
        }

        const requestBody = {
          customer_id: String(customerId),
          product_id: product.id,
          quantity: 1,
        };

        if (defaultVariant && defaultVariant.id) {
          requestBody.variant_id = defaultVariant.id;
        }

        const response = await fetch(
          "https://evercorenutrition.com/ev_admin/api/cart/",
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          },
        );

        if (response.ok) {
          await fetchCartData();
          window.dispatchEvent(new Event("cartUpdated"));
          // Optional: Show success feedback
        } else {
          console.error("Failed to add to cart:", await response.text());
        }
      } catch (error) {
        console.error("Error adding to cart:", error);
      }
    } else {
      // Guest cart logic
      const guestCart = getGuestCart();

      const defaultVariant =
        product.variants && product.variants.length > 0
          ? product.variants.find((v) => v.is_bestseller === true) ||
            product.variants[0]
          : null;

      const existingItemIndex = guestCart.findIndex(
        (item) =>
          item.product_id === product.id &&
          (item.variant_id || null) === (defaultVariant?.id || null) &&
          !item.combo_id,
      );

      const sellingPrice = parseFloat(
        defaultVariant?.selling_price ||
          product.selling_price ||
          product.price ||
          0,
      );

      const originalMRP = parseFloat(
        defaultVariant?.mrp ||
          defaultVariant?.price ||
          product.mrp ||
          product.price ||
          product.original_price ||
          sellingPrice
      );

      const newItem = {
        product_id: product.id,
        name: product.name,
        product_name: product.name,
        quantity: 1,
        unit_price: sellingPrice,
        price: sellingPrice,
        original_mrp: originalMRP,
        variant_mrp: originalMRP,
        image: defaultVariant?.main_image || product.main_image,
        product_image: defaultVariant?.main_image || product.main_image,
        item_type: "product",
      };

      if (defaultVariant) {
        newItem.variant_id = defaultVariant.id;
        newItem.variant_flavour = defaultVariant.flavour;
        newItem.variant_weight_display = defaultVariant.weight_display;
      }

      if (existingItemIndex >= 0) {
        guestCart[existingItemIndex].quantity += 1;
      } else {
        guestCart.push(newItem);
      }

      saveGuestCart(guestCart);
      fetchGuestCart();
      window.dispatchEvent(new Event("guestCartUpdated"));
    }
  };

  // useEffect(() => {
  //   const handleScroll = () => {
  //     const header = document.querySelector('header');
  //     if (!header) return;
  //     window.scrollY > 20 ? header.classList.add('active') : header.classList.remove('active');
  //   };
  //   window.addEventListener('scroll', handleScroll);
  //   import('feather-icons').then(({ default: feather }) => feather.replace());
  //   return () => window.removeEventListener('scroll', handleScroll);
  // }, []);

  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector("header");
      if (!header) return;
      window.scrollY > 20
        ? header.classList.add("active")
        : header.classList.remove("active");

      // Fix bottom nav - always keep labels visible regardless of scroll
      const bottomNav = document.querySelector(".mobile-bottom-nav");
      if (bottomNav) {
        bottomNav.style.transform = "none";
        bottomNav.style.height = "auto";
      }
    };
    window.addEventListener("scroll", handleScroll);
    import("feather-icons").then(({ default: feather }) => feather.replace());
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchQuery.trim().length > 2) performSearch(searchQuery);
      else setSearchResults([]);
    }, 500);
    return () => clearTimeout(delayDebounce);
  }, [searchQuery]);

  const performSearch = async (query) => {
    setIsSearching(true);
    try {
      const response = await fetch(
        `https://evercorenutrition.com/ev_admin/api/products/search/?q=${encodeURIComponent(query)}`,
      );
      const data = await response.json();
      setSearchResults(data.results || []);
    } catch (error) {
      console.error("Search error:", error);
      setSearchResults([]);
    } finally {
      setIsSearching(false);
    }
  };

  const handleSearchInput = (e) => setSearchQuery(e.target.value);
  const clearSearch = () => {
    setSearchQuery("");
    setSearchResults([]);
    setShowSearch(false);
  };
  const handleProductClick = (productId) => {
    navigate(`/product/${productId}`);
    clearSearch();
  };

  const getImageUrl = (imagePath) => {
    if (!imagePath) return "/assets/images/placeholder.jpg";
    if (imagePath.startsWith("http")) return imagePath;
    return `https://evercorenutrition.com${imagePath}`;
  };

  const cartItemCount = isAuthenticated
    ? cartData?.total_items || 0
    : guestCartData?.total_items || 0;
  const displayCartData = isAuthenticated ? cartData : guestCartData;

  const currentPromo = promos[currentPromoIndex];
  const formatPromoText = (promo) => {
    if (
      promo.description &&
      promo.description !== promo.title &&
      promo.description.length > 10
    )
      return promo.description;
    return promo.display_text || `${promo.code} - ${promo.discount_value}% OFF`;
  };

  const getUserDisplayName = () => {
    if (!userData) return "User";
    return (
      userData.full_name ||
      (userData.first_name && userData.last_name
        ? `${userData.first_name} ${userData.last_name}`
        : null) ||
      userData.first_name ||
      userData.username ||
      userData.name ||
      (userData.email ? userData.email.split("@")[0] : "User")
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target))
        setShowUserDropdown(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div>
      {/* Custom Tooltip */}
      {showTooltip && (
        <div
          className="custom-tooltip"
          style={{ left: tooltipPosition.x, top: tooltipPosition.y }}
        >
          <div className="tooltip-content">{tooltipText}</div>
          <div className="tooltip-arrow"></div>
        </div>
      )}

      {/* Announcement Bar */}
      <div className="announcement-bar">
        <p className="announcement-text">
          {promoLoading ? (
            <>⚡ Loading offers...</>
          ) : promos.filter((p) => p.discount_value > 0).length > 0 &&
            currentPromo ? (
            <>
              {/* <span className="promo-icon">⚡</span> */}
              <span className="promo-message">
                {formatPromoText(currentPromo)}
              </span>
              <span className="promo-code">
                {currentPromo.code && `Use Code: ${currentPromo.code}`}
              </span>
              <a href="/Shop" className="promo-cta">
                Shop Now →
              </a>
            </>
          ) : null}
        </p>
      </div>
      <TopBarAnnouncement />

      {/* Header */}
      <header>
        <div className="top-nav top-header sticky-header">
          <div className="container-fluid-lg">
            <div className="row">
              <div className="col-12 center-nav">
                <div className="navbar-top">
                  <button
                    className="navbar-toggler d-xl-none d-inline navbar-menu-button me-2"
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#primaryMenu"
                  >
                    <span className="navbar-toggler-icon">
                      <i className="fa-solid fa-bars"></i>
                    </span>
                  </button>

                  <a
                    href="/"
                    className="web-logo nav-logo"
                    style={{ textDecoration: "none"}}
                  >
                    <h2
                      style={{
                        fontWeight: "800",
                        fontSize: "35px",
                        color: "#000",
                        marginTop:"6px"
                      }}
                    >
                      EVERCORE
                    </h2>
                    <p style={{ color: "#000" }}>Honest Science for Everyday Performance</p>
                  </a>

                  <div className="header-nav-middle">
                    <div className="main-nav navbar navbar-expand-xl navbar-light navbar-sticky">
                      <div
                        className="offcanvas offcanvas-collapse order-xl-2"
                        id="primaryMenu"
                      >
                        <div className="offcanvas-header navbar-shadow">
                          <h5>Menu</h5>
                          <button
                            className="btn-close lead"
                            type="button"
                            data-bs-dismiss="offcanvas"
                          ></button>
                        </div>
                        <div className="offcanvas-body">
                          <ul className="navbar-nav">
                            <li className="nav-item">
                              <a
                                className="nav-link nav-link1 ps-xl-2 ps-0 text-black"
                                href="/"
                              >
                                Home
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className="nav-link nav-link1 ps-xl-2 ps-0 text-black"
                                href="/shop"
                              >
                                Shop
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className="nav-link nav-link1 ps-xl-2 ps-0"
                                href="/Ourstory"
                              >
                                Our Story
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className="nav-link nav-link1 ps-xl-2 ps-0"
                                href="/authenticity"
                              >
                                Authenticity
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className="nav-link nav-link1 ps-xl-2 ps-0"
                                href="/Blog"
                              >
                                Learn
                              </a>
                            </li>
                            <li className="nav-item d-md-none">
                              <a
                                className="nav-link nav-link1 ps-xl-2 ps-0"
                                href="/recipe"
                              >
                                Recipe
                              </a>
                            </li>
                            <NavDropdown title="Help" id="help-dropdown">
                              <NavDropdown.Item
                                as={Link}
                                to="/policies/shipping"
                              >
                                Orders and shipping Policy
                              </NavDropdown.Item>
                              <NavDropdown.Item as={Link} to="/policies/return">
                                Return Policy
                              </NavDropdown.Item>
                              <NavDropdown.Item
                                as={Link}
                                to="/policies/privacy"
                              >
                                Privacy Policy
                              </NavDropdown.Item>
                              <NavDropdown.Item as={Link} to="/faq">
                                FAQ's
                              </NavDropdown.Item>
                            </NavDropdown>
                            <li className="nav-item d-block d-md-none">
                              <a
                                className="nav-link nav-link1 ps-xl-2 ps-0"
                                href="/Contact"
                              >
                                Contact Us
                              </a>
                            </li>

                            {/* Sidebar Login */}

                            {/* <li className="nav-item d-block d-md-none">
                              {isAuthenticated ? (
                                <button className="btn header-wishlist nav-link nav-link1" style={{ textAlign: 'start', paddingTop:'12px' }} onClick={() => navigate('/UserAccount')}>
                                  <i className="fa-regular fa-user"></i> My Profile
                                </button>
                              ) : (
                                <button className="btn header-wishlist nav-link nav-link1" style={{ textAlign: 'start', paddingTop:'12px' }} onClick={() => setshowLogin(true)}>
                                  <i className="fa-solid fa-right-to-bracket"></i> Log in
                                </button>
                              )}
                            </li>
                             {isAuthenticated && (
                              <li className="nav-item d-block d-md-none">
                                <button className="btn header-wishlist nav-link nav-link1" style={{ textAlign: 'start', paddingTop:'12px', color: '#dc3545' }} onClick={openLogoutConfirm}>
                                  <i className="fa-solid fa-sign-out-alt"></i> Logout
                                </button>
                              </li>
                            )}  */}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="rightside-box">
                    <div className="search-full">
                      <div className="input-group">
                        <span className="input-group-text">
                          <i data-feather="search" className="font-light"></i>
                        </span>
                        <input
                          type="text"
                          className="form-control search-type"
                          placeholder="Search here.."
                          value={searchQuery}
                          onChange={handleSearchInput}
                        />
                        <span
                          className="input-group-text close-search"
                          onClick={clearSearch}
                        >
                          <i data-feather="x" className="font-light"></i>
                        </span>
                      </div>
                      {searchQuery.length > 0 && (
                        <div
                          className="search-results-dropdown"
                          style={{
                            position: "absolute",
                            top: "100%",
                            left: 0,
                            right: 0,
                            background: "white",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            maxHeight: "400px",
                            overflowY: "auto",
                            zIndex: 1000,
                            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                          }}
                        >
                          {isSearching && (
                            <div
                              style={{ padding: "10px", textAlign: "center" }}
                            >
                              Searching...
                            </div>
                          )}
                          {!isSearching &&
                            searchResults.length > 0 &&
                            searchResults.map((product) => (
                              <div
                                key={product.id}
                                onClick={() => handleProductClick(product.id)}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "10px",
                                  cursor: "pointer",
                                  borderBottom: "1px solid #eee",
                                }}
                                onMouseEnter={(e) =>
                                  (e.currentTarget.style.background = "#f5f5f5")
                                }
                                onMouseLeave={(e) =>
                                  (e.currentTarget.style.background = "white")
                                }
                              >
                                <img
                                  src={getImageUrl(product.main_image)}
                                  alt={product.name}
                                  style={{
                                    width: "50px",
                                    height: "50px",
                                    objectFit: "cover",
                                    marginRight: "10px",
                                  }}
                                />
                                <div>
                                  <h4
                                    style={{
                                      margin: "0 0 5px 0",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {product.name}
                                  </h4>
                                  <p
                                    style={{
                                      margin: 0,
                                      fontSize: "13px",
                                      color: "#2b7e2b",
                                    }}
                                  >
                                    ₹{product.selling_price}
                                    {product.price > product.selling_price && (
                                      <span
                                        style={{
                                          textDecoration: "line-through",
                                          color: "#999",
                                          marginLeft: "5px",
                                        }}
                                      >
                                        ₹{product.price}
                                      </span>
                                    )}
                                    {product.discount > 0 && (
                                      <span
                                        style={{
                                          background: "#ff4444",
                                          color: "white",
                                          padding: "2px 6px",
                                          borderRadius: "3px",
                                          fontSize: "11px",
                                          marginLeft: "5px",
                                        }}
                                      >
                                        {product.discount}% off
                                      </span>
                                    )}
                                  </p>
                                </div>
                              </div>
                            ))}
                          {!isSearching &&
                            searchQuery.length > 2 &&
                            searchResults.length === 0 && (
                              <div
                                style={{ padding: "10px", textAlign: "center" }}
                              >
                                No products found
                              </div>
                            )}
                        </div>
                      )}
                    </div>

                    <ul className="right-side-menu">
                      <li className=""></li>
                      <li className="right-side">
                        <button
                          type="button"
                          className="btn p-0 position-relative header-wishlist tooltip-trigger"
                          onClick={() => setShowSearch(true)}
                          onMouseEnter={(e) =>
                            showTooltipMessage("Search Products", e)
                          }
                          onMouseLeave={hideTooltip}
                        >
                          <i data-feather="search"></i>
                        </button>
                      </li>
                      <li className="right-side">
                        <button
                          type="button"
                          className="btn p-0 position-relative header-wishlist tooltip-trigger"
                          onClick={() => setShowCartSidebar(true)}
                          onMouseEnter={(e) => {
                            const count = cartItemCount;
                            if (count > 0) {
                              showTooltipMessage(
                                `Cart (${count} item${count > 1 ? "s" : ""})`,
                                e,
                              );
                            } else {
                              showTooltipMessage("Your cart is empty", e);
                            }
                          }}
                          onMouseLeave={hideTooltip}
                        >
                          <i data-feather="shopping-cart"></i>
                          <span className="position-absolute top-0 start-100 translate-middle badge">
                            {cartItemCount}
                            <span className="visually-hidden">
                              items in cart
                            </span>
                          </span>
                        </button>
                      </li>
                      <li className="right-side">
                        <button
                          className="btn p-0 position-relative header-wishlist tooltip-trigger"
                          onClick={() => navigate("/Wishlist")}
                          onMouseEnter={(e) => {
                            if (isAuthenticated) {
                              if (wishlistCount > 0) {
                                showTooltipMessage(
                                  `Wishlist (${wishlistCount} item${wishlistCount > 1 ? "s" : ""})`,
                                  e,
                                );
                              } else {
                                showTooltipMessage("Your wishlist is empty", e);
                              }
                            } else {
                              showTooltipMessage("Login to view wishlist", e);
                            }
                          }}
                          onMouseLeave={hideTooltip}
                        >
                          <i className="fa-regular fa-heart"></i>
                          {isAuthenticated && wishlistCount > 0 && (
                            <span className="position-absolute top-0 start-100 translate-middle badge wishlist-badge">
                              {wishlistCount}
                              <span className="visually-hidden">
                                items in wishlist
                              </span>
                            </span>
                          )}
                        </button>
                      </li>
                      <li className="right-side" ref={dropdownRef}>
                        {isAuthenticated ? (
                          <div className="user-dropdown">
                            <button
                              className="btn p-0 position-relative header-wishlist user-icon-btn tooltip-trigger"
                              onClick={toggleUserDropdown}
                              onMouseEnter={(e) =>
                                showTooltipMessage(
                                  `Hello, ${getUserDisplayName()}`,
                                  e,
                                )
                              }
                              onMouseLeave={hideTooltip}
                            >
                              <i className="fa-regular fa-user"></i>
                            </button>
                            {showUserDropdown && (
                              <div className="dropdown-menu show">
                                <div className="user-info">
                                  <p className="user-name">
                                    {getUserDisplayName()}
                                  </p>
                                  {userData?.email && (
                                    <p className="user-email">
                                      {userData.email}
                                    </p>
                                  )}
                                  {userData?.phone && (
                                    <p className="user-phone">
                                      {userData.phone}
                                    </p>
                                  )}
                                </div>
                                <hr />
                                <button
                                  className="dropdown-item"
                                  onClick={() =>
                                    handleDropdownItemClick("/UserAccount")
                                  }
                                >
                                  <i className="fa-regular fa-user"></i> My
                                  Profile
                                </button>
                                <hr />
                                <button
                                  className="dropdown-item logout-btn"
                                  onClick={openLogoutConfirm}
                                >
                                  <i className="fa-solid fa-sign-out-alt"></i>{" "}
                                  Logout
                                </button>
                              </div>
                            )}
                          </div>
                        ) : (
                          <button
                            className="btn p-0 position-relative header-wishlist tooltip-trigger"
                            onClick={() => setshowLogin(true)}
                            onMouseEnter={(e) =>
                              showTooltipMessage("Login to your account", e)
                            }
                            onMouseLeave={hideTooltip}
                          >
                            <i className="fa-solid fa-right-to-bracket"></i>
                          </button>
                        )}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {showLogin && (
          <Login setOpen={setshowLogin} onLoginSuccess={handleLoginSuccess} />
        )}
      </header>

      {/* Logout Confirmation Popup */}
      {showLogoutConfirm && (
        <div
          className="logout-confirm-overlay"
          onClick={() => setShowLogoutConfirm(false)}
        >
          <div
            className="logout-confirm-popup"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="logout-confirm-header">
              <div className="logout-icon">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9"
                    stroke="#dc3545"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M16 17L21 12L16 7"
                    stroke="#dc3545"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M21 12H9"
                    stroke="#dc3545"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <h3>Logout Confirmation</h3>
            </div>
            <div className="logout-confirm-body">
              <p>Are you sure you want to logout?</p>
              <p className="logout-warning-text">
                You will need to login again to access your account and
                wishlist.
              </p>
            </div>
            <div className="logout-confirm-footer">
              <button
                className="logout-cancel-btn"
                onClick={() => setShowLogoutConfirm(false)}
              >
                Cancel
              </button>
              <button
                className="logout-confirm-btn"
                onClick={handleLogout}
                disabled={isLoggingOut}
              >
                {isLoggingOut ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      style={{ marginRight: "8px" }}
                    ></span>
                    Logging out...
                  </>
                ) : (
                  "Yes, Logout"
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Cart Sidebar */}
      <div
        className={`cart-sidebar-overlay ${showCartSidebar ? "active" : ""}`}
        onClick={() => setShowCartSidebar(false)}
      >
        <div
          className={`cart-sidebar ${showCartSidebar ? "active" : ""}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="cart-sidebar-header">
            <h3>Your Cart</h3>
            <button
              className="cart-close-btn"
              onClick={() => setShowCartSidebar(false)}
            >
              ×
            </button>
          </div>

          <div className="cart-sidebar-body">
            {isMergingCart ? (
              <div className="cart-loading-state">
                <div className="spinner"></div>
                <p>Merging your cart...</p>
              </div>
            ) : displayCartData?.items?.length > 0 ? (
              <>
                <div className="cart-items-list">
                  {displayCartData.items.map((item, index) => {
                    const itemImage = getCartImage(item);
                    const itemName = getItemName(item);
                    const variantDisplay = getVariantDisplay(item);
                    const isCombo = item.item_type === "combo";
                    const comboPreview = getComboItemsPreview(item);
                 

                    const itemPrice = parseFloat(item.unit_price || item.price || 0);

                    const itemMRP = parseFloat(
                      item.variant_mrp ||
                        item.original_mrp ||
                        item.mrp ||
                        item.product_mrp ||
                        itemPrice
                    );                      
                    // fallback


                    return (
                      <div className="cart-sidebar-item" key={item.id || index}>
                        <div className="cart-item-image">
                          {itemImage ? (
                            <img src={itemImage} alt={itemName} />
                          ) : (
                            <div className="cart-item-placeholder">
                              {isCombo ? "🎁" : "🛍️"}
                            </div>
                          )}
                        </div>
                        <div className="cart-item-details">
                          <h4>{itemName}</h4>
                          {isCombo && comboPreview && (
                            <p className="cart-item-combo-preview">
                              {comboPreview}
                            </p>
                          )}
                          {variantDisplay && (
                            <p className="cart-item-variant">
                              {variantDisplay}
                            </p>
                          )}
                          <div className="cart-item-price-row">
                            <span className="cart-item-quantity">
                              Qty: {item.quantity}
                            </span>
                            <span className="cart-item-price">
                              ₹{itemPrice.toFixed(2)}
                            </span>

                            {itemMRP > itemPrice && (
                              <span
                                style={{
                                  textDecoration: "line-through",
                                  color: "#999",
                                  marginLeft: "8px",
                                  fontSize: "13px",
                                }}
                              >
                                ₹{itemMRP.toFixed(2)}
                              </span>
                            )}


        </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="cart-sidebar-summary">
                  <div className="summary-row">
                    <span>Subtotal:</span>
                    <span>₹{orderSummary.subtotal.toFixed(2)}</span>
                  </div>
                  <div className="summary-row">
                    <span>Items:</span>
                    <span>{orderSummary.itemCount}</span>
                  </div>
                  <div className="summary-row total">
                    <span>Total:</span>
                    <span>₹{orderSummary.total.toFixed(2)}</span>
                  </div>
                </div>

                <div className="cart-sidebar-actions">
                  <button
                    className="cart-view-btn"
                    onClick={() => {
                      setShowCartSidebar(false);
                      navigate("/Cart");
                    }}
                  >
                    View Cart ({cartItemCount})
                  </button>
                  <button
                    className="cart-checkout-btn"
                    onClick={handleCheckoutClick}
                  >
                    Checkout →
                  </button>
                </div>

                {/* Recommended Products Section - Bestsellers only */}
                {!isLoadingRecommended &&
                  (recommendedProducts.length > 0 ||
                    bestsellerCombos.length > 0) && (
                    <div className="cart-recommended-section">
                      <div className="recommended-header">
                        <h4> Recommended for You</h4>
                      </div>
                      <div className="recommended-products-list">
                        {/* Mix products and combos together */}
                        {[...recommendedProducts, ...bestsellerCombos].map(
                          (item, index) => {
                            // Check if item is a combo (has combo_id or image_url property)
                            const isCombo =
                              item.combo_id !== undefined ||
                              item.image_url !== undefined;
                            const itemId = isCombo ? item.id : item.id;
                            const itemName = isCombo ? item.name : item.name;
                            const itemImage = isCombo
                              ? getImageUrl(item.image_url)
                              : getImageUrl(
                                  item.main_image ||
                                    (item.images &&
                                      item.images.find((img) => img.is_main)
                                        ?.image_url) ||
                                    item.variants?.[0]?.main_image,
                                );
                            const currentPrice = isCombo
                              ? parseFloat(item.selling_price).toFixed(2)
                              : parseFloat(
                                  item.selling_price || item.price || 0,
                                ).toFixed(2);
                            const originalPrice = isCombo
                              ? parseFloat(item.mrp).toFixed(2)
                              : item.price &&
                                  item.selling_price &&
                                  item.price > item.selling_price
                                ? parseFloat(item.price).toFixed(2)
                                : null;
                            const discount = isCombo
                              ? Math.floor(parseFloat(item.discount))
                              : null;

                            return (
                              <div
                                key={`${isCombo ? "combo" : "product"}-${itemId}`}
                                className="recommended-product-item"
                              >
                                <div className="recommended-product-image">
                                  <img
                                    src={itemImage}
                                    alt={itemName}
                                    onClick={() => {
                                      setShowCartSidebar(false);
                                      if (isCombo) {
                                        navigate(`/combo/${itemId}`);
                                      } else {
                                        navigate(`/product/${itemId}`);
                                      }
                                    }}
                                  />
                                  {isCombo && (
                                    <span className="combo-badge-tag">
                                      {item.is_bestseller
                                        ? "Bestseller"
                                        : item.is_most_popular
                                          ? "Popular"
                                          : "Combo"}
                                    </span>
                                  )}
                                </div>
                                <div className="recommended-product-info">
                                  <p
                                    className="recommended-product-name"
                                    onClick={() => {
                                      setShowCartSidebar(false);
                                      if (isCombo) {
                                        navigate(`/combo/${itemId}`);
                                      } else {
                                        navigate(`/product/${itemId}`);
                                      }
                                    }}
                                  >
                                    {itemName.length > 35
                                      ? itemName.substring(0, 32) + "..."
                                      : itemName}
                                  </p>
                                  <div className="recommended-product-price">
                                    <span className="current-price">
                                      ₹{currentPrice}
                                    </span>
                                    {originalPrice && (
                                      <span className="original-price">
                                        ₹{originalPrice}
                                      </span>
                                    )}
                                  </div>
                                  <button
                                    className="recommended-add-btn"
                                    onClick={() => {
                                      if (isCombo) {
                                        addComboToCart(item);
                                      } else {
                                        addToCartFromRecommended(item);
                                      }
                                    }}
                                  >
                                    <i className="fa-solid fa-plus"></i> Add to
                                    Cart
                                  </button>
                                </div>
                              </div>
                            );
                          },
                        )}
                      </div>
                    </div>
                  )}
              </>
            ) : (
              <div className="cart-empty-state">
                <div className="cart-empty-icon">🛒</div>
                <p>Your cart is empty</p>
                <button
                  className="cart-shop-now-btn"
                  onClick={() => {
                    setShowCartSidebar(false);
                    navigate("/shop");
                  }}
                >
                  Shop Now →
                </button>

                {!isLoadingRecommended &&
                  (recommendedProducts.length > 0 ||
                    bestsellerCombos.length > 0) && (
                    <div className="cart-recommended-section">
                      <div className="recommended-header">
                        <h4> Recommended for You</h4>
                      </div>
                      <div className="recommended-products-list">
                        {/* Mix products and combos together */}
                        {[...recommendedProducts, ...bestsellerCombos].map(
                          (item, index) => {
                            // Check if item is a combo (has combo_id or image_url property)
                            const isCombo =
                              item.combo_id !== undefined ||
                              item.image_url !== undefined;
                            const itemId = isCombo ? item.id : item.id;
                            const itemName = isCombo ? item.name : item.name;
                            const itemImage = isCombo
                              ? getImageUrl(item.image_url)
                              : getImageUrl(
                                  item.main_image ||
                                    (item.images &&
                                      item.images.find((img) => img.is_main)
                                        ?.image_url) ||
                                    item.variants?.[0]?.main_image,
                                );
                            const currentPrice = isCombo
                              ? parseFloat(item.selling_price).toFixed(2)
                              : parseFloat(
                                  item.selling_price || item.price || 0,
                                ).toFixed(2);
                            const originalPrice = isCombo
                              ? parseFloat(item.mrp).toFixed(2)
                              : item.price &&
                                  item.selling_price &&
                                  item.price > item.selling_price
                                ? parseFloat(item.price).toFixed(2)
                                : null;
                            const discount = isCombo
                              ? Math.floor(parseFloat(item.discount))
                              : null;

                            return (
                              <div
                                key={`${isCombo ? "combo" : "product"}-${itemId}`}
                                className="recommended-product-item"
                              >
                                <div className="recommended-product-image">
                                  <img
                                    src={itemImage}
                                    alt={itemName}
                                    onClick={() => {
                                      setShowCartSidebar(false);
                                      if (isCombo) {
                                        navigate(`/combo/${itemId}`);
                                      } else {
                                        navigate(`/product/${itemId}`);
                                      }
                                    }}
                                  />
                                  {isCombo && (
                                    <span className="combo-badge-tag">
                                      {item.is_bestseller
                                        ? "Bestseller"
                                        : item.is_most_popular
                                          ? "Popular"
                                          : "Combo"}
                                    </span>
                                  )}
                                </div>
                                <div className="recommended-product-info">
                                  <p
                                    className="recommended-product-name"
                                    onClick={() => {
                                      setShowCartSidebar(false);
                                      if (isCombo) {
                                        navigate(`/combo/${itemId}`);
                                      } else {
                                        navigate(`/product/${itemId}`);
                                      }
                                    }}
                                  >
                                    {itemName.length > 35
                                      ? itemName.substring(0, 32) + "..."
                                      : itemName}
                                  </p>
                                  <div className="recommended-product-price">
                                    <span className="current-price">
                                      ₹{currentPrice}
                                    </span>
                                    {originalPrice && (
                                      <span className="original-price">
                                        ₹{originalPrice}
                                      </span>
                                    )}
                                  </div>
                                  <button
                                    className="recommended-add-btn"
                                    onClick={() => {
                                      if (isCombo) {
                                        addComboToCart(item);
                                      } else {
                                        addToCartFromRecommended(item);
                                      }
                                    }}
                                  >
                                    <i className="fa-solid fa-plus"></i> Add to
                                    Cart
                                  </button>
                                </div>
                              </div>
                            );
                          },
                        )}
                      </div>
                    </div>
                  )}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Mobile bottom nav */}
      <div className="mobile-bottom-nav d-md-none">
        <ul className="nav-list">
          <li className="nav-item">
            <button
              type="button"
              className="nav-btn"
              data-bs-toggle="offcanvas"
              data-bs-target="#primaryMenu"
            >
              <i className="iconly-Category icli"></i>
              <span>Menu</span>
            </button>
          </li>
          <li className="nav-item">
            <button
              type="button"
              className="nav-btn"
              onClick={() => setShowSearch(true)}
            >
              <i className="iconly-Search icli"></i>
              <span>Search</span>
            </button>
          </li>
          <li className="nav-item">
            <a href="/Wishlist" className="nav-btn">
              <i className="iconly-Heart icli"></i>
              <span>Wish {wishlistCount > 0 ? `(${wishlistCount})` : ""}</span>
            </a>
          </li>
          <li className="nav-item">
            <button
              className="nav-btn"
              onClick={() => setShowCartSidebar(true)}
            >
              <i className="iconly-Bag-2 icli"></i>
              <span>Cart {cartItemCount > 0 ? `(${cartItemCount})` : ""}</span>
            </button>
          </li>
          <li className="nav-item">
            {isAuthenticated ? (
              <button
                className="nav-btn"
                onClick={() => navigate("/UserAccount")}
              >
                <i className="iconly-Profile icli"></i>
                <span>Profile</span>
              </button>
            ) : (
              <button className="nav-btn" onClick={() => setshowLogin(true)}>
                <i className="iconly-Profile icli"></i>
                <span>Login</span>
              </button>
            )}
          </li>
        </ul>
      </div>

      {/* Search Modal */}
      {showSearch && (
        <div className="search-modal-overlay" onClick={clearSearch}>
          <div className="search-modal" onClick={(e) => e.stopPropagation()}>
            <button
              className="search-close-btn"
              onClick={clearSearch}
              aria-label="Close search"
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1L13 13M13 1L1 13"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </button>
            <input
              type="text"
              placeholder="Search for Protein"
              className="search-input"
              autoFocus
              value={searchQuery}
              onChange={handleSearchInput}
            />
            {searchQuery.length > 0 && (
              <div
                className="search-results"
                style={{
                  maxHeight: "300px",
                  overflowY: "auto",
                  margin: "10px 0",
                  padding: "0 20px",
                }}
              >
                {isSearching && (
                  <div style={{ textAlign: "center", padding: "10px" }}>
                    Searching...
                  </div>
                )}
                {!isSearching &&
                  searchResults.length > 0 &&
                  searchResults.map((product) => (
                    <div
                      key={product.id}
                      onClick={() => handleProductClick(product.id)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "10px",
                        cursor: "pointer",
                        borderBottom: "1px solid #eee",
                      }}
                    >
                      <img
                        src={getImageUrl(product.main_image)}
                        alt={product.name}
                        style={{
                          width: "40px",
                          height: "40px",
                          objectFit: "cover",
                          marginRight: "10px",
                        }}
                      />
                      <div>
                        <h4 style={{ margin: 0, fontSize: "14px" }}>
                          {product.name}
                        </h4>
                        <p
                          style={{
                            margin: "5px 0 0",
                            fontSize: "13px",
                            color: "#2b7e2b",
                          }}
                        >
                          ₹{product.selling_price}
                        </p>
                      </div>
                    </div>
                  ))}
                {!isSearching &&
                  searchQuery.length > 2 &&
                  searchResults.length === 0 && (
                    <div style={{ textAlign: "center", padding: "10px" }}>
                      No products found
                    </div>
                  )}
              </div>
            )}
            <div className="search-banner">
              <div className="banner-content">
                <div className="banner-text">
                  <h3>Fuel Your Strength</h3>
                  <p>High-Quality Protein to Power Every Workout & Recovery.</p>
                  <a href="/shop">
                    <button className="searchshop-btn">Shop Now</button>
                  </a>
                </div>
                <div className="banner-image">
                  <img src="/assets/images/Yeast_Protein.png" alt="Protein" />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <style>{`
        /* Custom Tooltip Styles */
        .custom-tooltip {
          position: fixed;
          transform: translateX(-50%);
          z-index: 20001;
          pointer-events: none;
          animation: tooltipFadeIn 0.2s ease;
        }
        
        .tooltip-content {
          background: #333;
          color: white;
          padding: 6px 12px;
          border-radius: 6px;
          font-size: 12px;
          font-weight: 500;
          white-space: nowrap;
          box-shadow: 0 2px 8px rgba(0,0,0,0.15);
        }
        
        .tooltip-arrow {
          position: absolute;
          bottom: -5px;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
          border-top: 6px solid #333;
        }
        
        @keyframes tooltipFadeIn {
          from {
            opacity: 0;
            transform: translateX(-50%) translateY(5px);
          }
          to {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
          }
        }

        /* Combo Badge Styles */
        .combo-badge {
          background: linear-gradient(135deg, #ff6b6b, #ff8e53);
          color: white;
          padding: 4px 10px;
          border-radius: 20px;
          font-size: 11px;
          font-weight: 600;
        }
        
        .combo-badge-tag {
          position: absolute;
          top: 5px;
          left: 5px;
          padding: 2px 8px;
          border-radius: 12px;
          font-size: 9px;
          font-weight: 700;
          z-index: 2;
        }
        
        .combo-badge-tag.bestseller {
          background: #ff9800;
          color: white;
        }
        
        .combo-badge-tag.most-popular {
          background: #9c27b0;
          color: white;
        }
        
        .combo-item {
          position: relative;
        }
        
        .combo-pack-info {
          font-size: 11px;
          color: #888;
          margin: 5px 0;
          display: flex;
          align-items: center;
          gap: 4px;
        }
        
        .combo-pack-info i {
          font-size: 10px;
        }
        
        .discount-badge {
          background: #e53935;
          color: white;
          padding: 2px 6px;
          border-radius: 12px;
          font-size: 10px;
          font-weight: 600;
          margin-left: 6px;
        }
        
        .combo-add-btn {
          background: #ff9800 !important;
          border-color: #ff9800 !important;
          color: white !important;
        }
        
        .combo-add-btn:hover {
          background: #f57c00 !important;
        }

        /* Cart Sidebar Styles */
        .cart-sidebar-overlay {
          position: fixed;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          background-color: rgba(0, 0, 0, 0.5);
          z-index: 10001;
          visibility: hidden;
          opacity: 0;
          transition: visibility 0.3s ease, opacity 0.3s ease;
        }
        
        .cart-sidebar-overlay.active {
          visibility: visible;
          opacity: 1;
        }
        
        .cart-sidebar {
          position: fixed;
          top: 0;
          right: -100%;
          width: 100%;
          max-width: 400px;
          height: 100%;
          background: white;
          box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
          z-index: 10002;
          transition: right 0.3s ease;
          display: flex;
          flex-direction: column;
        }
        
        .cart-sidebar.active {
          right: 0;
        }
        
        .cart-sidebar-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px;
          border-bottom: 1px solid #eee;
        }
        
        .cart-sidebar-header h3 {
          margin: 0;
          font-size: 20px;
          font-weight: 600;
        }
        
        .cart-close-btn {
          background: none;
          border: none;
          font-size: 28px;
          cursor: pointer;
          color: #999;
          transition: color 0.2s;
        }
        
        .cart-close-btn:hover {
          color: #333;
        }
        
        .cart-sidebar-body {
          flex: 1;
          overflow-y: auto;
          padding: 20px;
        }
        
        .cart-items-list {
          display: flex;
          flex-direction: column;
          gap: 15px;
          margin-bottom: 20px;
        }
        
        .cart-sidebar-item {
          display: flex;
          gap: 12px;
          padding: 10px;
          background: #f9f9f9;
          border-radius: 10px;
          border: 1px solid #eee;
        }
        
        .cart-item-image {
          width: 70px;
          height: 70px;
          flex-shrink: 0;
          background: white;
          border-radius: 8px;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .cart-item-image img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        
        .cart-item-placeholder {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 30px;
          background: #f0f0f0;
        }
        
        .cart-item-details {
          flex: 1;
        }
        
        .cart-item-details h4 {
          margin: 0 0 4px 0;
          font-size: 14px;
          font-weight: 600;
          color: #333;
        }
        
        .cart-item-combo-preview,
        .cart-item-variant {
          font-size: 11px;
          color: #888;
          margin: 2px 0;
        }
        
        .cart-item-price-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 8px;
        }
        
        .cart-item-quantity {
          font-size: 12px;
          color: #666;
        }
        
        .cart-item-price {
          font-size: 14px;
          font-weight: 700;
          color: #000;
        }
        
        .cart-sidebar-summary {
          padding: 15px 0;
          border-top: 1px solid #eee;
          border-bottom: 1px solid #eee;
          margin-bottom: 20px;
        }
        
        .summary-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          font-size: 14px;
        }
        
        .summary-row.total {
          margin-top: 10px;
          padding-top: 10px;
          border-top: 1px solid #eee;
          font-weight: 700;
          font-size: 16px;
        }
        
        .cart-sidebar-actions {
          display: flex;
          flex-direction: column;
          gap: 10px;
          margin-bottom: 20px;
        }
        
        .cart-view-btn,
        .cart-checkout-btn,
        .cart-shop-now-btn {
          width: 100%;
          padding: 12px;
          border: none;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s;
        }
        
        .cart-view-btn {
          background: #f0f0f0;
          color: #333;
        }
        
        .cart-view-btn:hover {
          background: #e0e0e0;
        }
        
        .cart-checkout-btn {
          background: #000;
          color: white;
        }
        
        .cart-checkout-btn:hover {
          background: #333;
        }
        
        .cart-shop-now-btn {
          background: #000;
          color: white;
          margin-top: 10px;
        }
        
        .cart-empty-state {
          text-align: center;
          padding: 40px 20px;
        }
        
        .cart-empty-icon {
          font-size: 60px;
          margin-bottom: 15px;
          opacity: 0.5;
        }
        
        .cart-empty-state p {
          color: #666;
          margin-bottom: 20px;
        }
        
        .cart-loading-state {
          text-align: center;
          padding: 60px 20px;
        }
        
        .cart-loading-state .spinner {
          width: 40px;
          height: 40px;
          border: 3px solid #f3f3f3;
          border-top: 3px solid #000;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin: 0 auto 15px;
        }
        
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        /* Recommended Products Styles */
        .cart-recommended-section {
          margin-top: 20px;
          padding-top: 20px;
          border-top: 1px solid #eee;
        }
        
        .empty-cart-rec {
          margin-top: 30px;
          border-top: 1px solid #eee;
        }
        
        .recommended-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 15px;
        }
        
        .recommended-header h4 {
          font-size: 16px;
          font-weight: 600;
          color: #333;
          margin: 0;
        }
        
        .recommended-badge {
          background: #ffd700;
          padding: 4px 8px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
        }
        
        .recommended-products-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        
        .recommended-product-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 10px;
          background: #fafafa;
          border-radius: 10px;
          border: 1px solid #f0f0f0;
          transition: all 0.2s;
        }
        
        .recommended-product-item:hover {
          background: #f5f5f5;
          border-color: #e0e0e0;
        }
        
        .recommended-product-image {
          position: relative;
          width: 60px;
          height: 60px;
          flex-shrink: 0;
          background: white;
          border-radius: 8px;
          overflow: hidden;
          cursor: pointer;
        }
        
        .recommended-product-image img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        
        .recommended-product-info {
          flex: 1;
        }
        
        .recommended-product-name {
          font-size: 13px;
          font-weight: 500;
          color: #333;
          margin: 0 0 6px 0;
          cursor: pointer;
          line-height: 1.3;
        }
        
        .recommended-product-name:hover {
          color: #000;
          text-decoration: underline;
        }
        
        .recommended-product-price {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 8px;
          margin-bottom: 8px;
        }
        
        .recommended-product-price .current-price {
          font-size: 14px;
          font-weight: 700;
          color: #000;
        }
        
        .recommended-product-price .original-price {
          font-size: 12px;
          color: #999;
          text-decoration: line-through;
        }
        
        .recommended-add-btn {
          background: transparent;
          border: 1px solid #000;
          color: #000;
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 11px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
          display: inline-flex;
          align-items: center;
          gap: 4px;
        }
        
        .recommended-add-btn i {
          font-size: 10px;
        }
        
        .recommended-add-btn:hover {
          background: #000;
          color: white;
        }

        /* User dropdown styles */
        .user-dropdown { position: relative; display: inline-block; }
        .user-icon-btn { cursor: pointer; }
        .user-dropdown .dropdown-menu {
          position: absolute; right: 0; top: 100%;
          background: white; min-width: 260px;
          box-shadow: 0 8px 16px rgba(0,0,0,0.1);
          border-radius: 8px; padding: 10px 0;
          z-index: 1000; margin-top: 10px; display: none;
        }
        .user-dropdown .dropdown-menu.show { display: block; }
        .user-dropdown .dropdown-menu .user-info { padding: 10px 15px; }
        .user-dropdown .dropdown-menu .user-name { font-weight: 600; margin: 0; color: #333; font-size: 14px; text-transform: capitalize; }
        .user-dropdown .dropdown-menu .user-email { font-size: 11px; color: #999; margin: 5px 0 0; word-break: break-all; }
        .user-dropdown .dropdown-menu .user-phone { font-size: 12px; color: #666; margin: 5px 0 0; }
        .user-dropdown .dropdown-menu hr { margin: 8px 0; border: none; border-top: 1px solid #eee; }
        .user-dropdown .dropdown-menu .dropdown-item {
          display: flex; align-items: center; gap: 8px;
          width: 100%; padding: 10px 15px; text-align: left;
          background: none; border: none; cursor: pointer;
          color: #333; font-size: 14px; transition: background 0.2s;
        }
        .user-dropdown .dropdown-menu .dropdown-item i { width: 16px; font-size: 14px; }
        .user-dropdown .dropdown-menu .dropdown-item:hover { background: #f5f5f5; }
        .user-dropdown .dropdown-menu .logout-btn { color: #dc3545; }
        .user-dropdown .dropdown-menu .logout-btn:hover { background: #ffebee; }

        /* Search Modal Styles */
        .search-modal-overlay {
          position: fixed; top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(0, 0, 0, 0.6);
          backdrop-filter: blur(4px);
          display: flex; align-items: flex-start; justify-content: center;
          z-index: 10000; padding-top: 80px;
        }
        .search-modal {
          background: white; width: 90%; max-width: 600px;
          border-radius: 20px; position: relative;
          padding: 48px 0 20px;
          animation: slideDown 0.3s ease;
        }
        .search-close-btn {
          position: absolute;
          top: 14px;
          right: 14px;
          width: 30px;
          height: 30px;
          padding: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f0f0f0;
          border: none;
          border-radius: 50%;
          color: #555;
          cursor: pointer;
          transition: background 0.2s, color 0.2s, transform 0.2s;
          z-index: 10;
          line-height: 1;
        }
        .search-close-btn:hover {
          background: #e0e0e0;
          color: #000;
          transform: rotate(90deg);
        }
        .search-input {
          width: calc(100% - 40px); margin: 0 20px;
          padding: 14px 16px;
          border: 2px solid #e0e0e0; border-radius: 12px;
          font-size: 16px; outline: none;
          transition: border-color 0.2s;
        }
        .search-input:focus { border-color: #000; }
        .search-banner {
          margin-top: 20px; padding: 20px;
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
          border-radius: 0 0 20px 20px;
        }
        .banner-content { display: flex; align-items: center; justify-content: space-between; }
        .banner-text h3 { margin: 0 0 10px; font-size: 18px; font-weight: 600; }
        .banner-text p  { margin: 0 0 15px; font-size: 14px; color: #666; }
        .searchshop-btn {
          background: #000; color: white; border: none;
          padding: 8px 20px; border-radius: 8px;
          font-size: 14px; font-weight: 500;
          cursor: pointer; transition: background 0.3s;
        }
        .searchshop-btn:hover { background: #333; }
        .banner-image img { width: 100px; height: auto; }
        @keyframes slideDown {
          from { transform: translateY(-30px); opacity: 0; }
          to   { transform: translateY(0);     opacity: 1; }
        }

        /* Logout Confirmation Popup Styles */
        .logout-confirm-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.6);
          backdrop-filter: blur(4px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 20000;
          animation: fadeIn 0.3s ease;
        }
        
        .logout-confirm-popup {
          background: white;
          border-radius: 20px;
          width: 90%;
          max-width: 420px;
          overflow: hidden;
          animation: slideUp 0.3s ease;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
        }
        
        .logout-confirm-header {
          text-align: center;
          padding: 30px 20px 20px;
          background: linear-gradient(135deg, #fff5f5 0%, #ffffff 100%);
        }
        
        .logout-icon {
          width: 80px;
          height: 80px;
          margin: 0 auto 15px;
          background: #fff0f0;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          animation: shake 0.5s ease;
        }
        
        .logout-confirm-header h3 {
          margin: 0;
          font-size: 22px;
          font-weight: 700;
          color: #333;
        }
        
        .logout-confirm-body {
          padding: 20px 30px;
          text-align: center;
        }
        
        .logout-confirm-body p {
          margin: 0 0 10px;
          font-size: 16px;
          color: #555;
        }
        
        .logout-warning-text {
          font-size: 13px;
          color: #999;
          margin-top: 8px;
        }
        
        .logout-confirm-footer {
          display: flex;
          gap: 12px;
          padding: 20px 30px 30px;
          border-top: 1px solid #eee;
        }
        
        .logout-cancel-btn,
        .logout-confirm-btn {
          flex: 1;
          padding: 12px 20px;
          border: none;
          border-radius: 10px;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        
        .logout-cancel-btn {
          background: #f0f0f0;
          color: #666;
        }
        
        .logout-cancel-btn:hover {
          background: #e0e0e0;
        }
        
        .logout-confirm-btn {
          background: #dc3545;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }
        
        .logout-confirm-btn:hover {
          background: #c82333;
          transform: translateY(-2px);
        }
        
        .logout-confirm-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
          transform: none;
        }
        
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes slideUp {
          from {
            transform: translateY(30px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          75% { transform: translateX(5px); }
        }

        /* Offcanvas backdrop removal */
        .offcanvas-backdrop {
          display: none !important;
          background: transparent !important;
          opacity: 0 !important;
        }
        
        #primaryMenu.offcanvas {
          box-shadow: none !important;
        }
        
        body.modal-open {
          overflow: auto !important;
          padding-right: 0 !important;
        }

        /* Badge styles */
        .wishlist-badge {
          background-color: #dc3545; color: white;
          font-size: 10px; padding: 2px 4px; border-radius: 50%;
          min-width: 18px; height: 18px;
          display: flex; align-items: center; justify-content: center;
        }
        .header-wishlist { position: relative; }
        .badge { background-color: #dc3545; }

        /* Announcement bar */
        .announcement-bar {
          background: linear-gradient(90deg, #1a1a1a 0%, #2d2d2d 100%);
          color: white; 
          padding: 8px 0; 
          text-align: center; 
          font-size: 14px;
          position: sticky;
          top: 0;
          z-index: 1002;
        }

        .announcement-bar-to {
          background: linear-gradient(90deg, #312581 0%, #312581);
          color: black !important; 
          padding: 5px 0; 
          text-align: center; 
          font-size: 14px;
          position: sticky;
          top: 38px;
          z-index: 1001;
        }

        /* Make header sticky too if needed */
        header {
          position: sticky;
          top: 76px;
          z-index: 1000;
          background: white;
        }
        .announcement-text {
          margin: 0; display: flex; align-items: center;
          justify-content: center; flex-wrap: wrap; gap: 8px;
        }
        .promo-message { color: #ffffff; }
        .promo-code    { color: #ffd700; font-weight: 600; }
        .promo-cta {
          color: white; text-decoration: none; font-weight: 600;
          padding: 4px 12px; background: rgba(255,255,255,0.1);
          border-radius: 20px; transition: all 0.3s ease;
        }
        .promo-cta:hover { background: #ff4d4d; color: white; }

@media (max-width: 480px) {
  .announcement-text { font-size: 10px; gap: 4px; padding: 0 5px; }
  .promo-code { font-size: 9px; }
  .promo-cta  { padding: 2px 6px; font-size: 9px; }
  .search-modal { padding-top: 52px; }
  .search-close-btn { top: 12px; right: 12px; }
  .cart-sidebar { max-width: 100%; }
  .logout-confirm-popup { width: 95%; }
  .logout-confirm-header h3 { font-size: 18px; }
  .logout-confirm-body p { font-size: 14px; }
  .logout-cancel-btn, .logout-confirm-btn { padding: 10px 16px; font-size: 14px; }
}

        /* Messages announcement bar styles */
        .announcement-bar-to {
          background: linear-gradient(90deg, #312581 0%, #312581);
          color: white !important; 
          padding: 8px 0; 
          text-align: center; 
          font-size: 14px;
          position: sticky;
          top: 38px;
          z-index: 1001;
          width: 100%;
        }

        .announcement-text {
          margin: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          gap: 12px;
        }

        .messages-slider {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          gap: 12px;
        }

        .message-title-badge {
          background: rgba(255, 255, 255, 0.2);
          padding: 4px 12px;
          border-radius: 20px;
          font-weight: 600;
          font-size: 12px;
          letter-spacing: 0.5px;
          white-space: nowrap;
        }

        .message-content {
          color: white;
          font-size: 13px;
        }

        .message-dots {
          display: flex;
          gap: 6px;
          margin-left: 8px;
        }

        .message-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.4);
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .message-dot.active {
          background: white;
          width: 16px;
          border-radius: 3px;
        }

        .message-dot:hover {
          background: rgba(255, 255, 255, 0.8);
        }

        /* Responsive */
        @media (max-width: 768px) {
          .announcement-bar-to {
            padding: 6px 0;
            top: 34px;
          }
          
          .message-title-badge {
            padding: 3px 8px;
            font-size: 10px;
          }
          
          .message-content {
            font-size: 11px;
          }
          
          .announcement-text {
            gap: 8px;
            padding: 0 10px;
          }
        }

        @media (max-width: 480px) {
          .messages-slider {
            flex-direction: column;
            gap: 6px;
          }
          
          .message-title-badge {
            white-space: normal;
          }
          
          .message-dots {
            margin-top: 4px;
          }
        }

/* Lock bottom nav - never change on scroll */
.mobile-bottom-nav {
  position: fixed !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  height: auto !important;
  min-height: 56px !important;
  transform: none !important;
  transition: none !important;
}

.mobile-bottom-nav .nav-btn span {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  font-size: 10px !important;
  height: auto !important;
  overflow: visible !important;
}

.mobile-bottom-nav .nav-btn i {
  display: block !important;
  font-size: 20px !important;
}

      `}</style>
         
    </div>
  );
}
